{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "id": "vault",
  "order": 3,
  "accent": "teal-blue",
  "eyebrow": "GOVERNED EVIDENCE",
  "title": "Vault",
  "valueStatement": "Preserve aircraft records and maintenance evidence with provenance and traceability.",
  "outcome": "Preserve. Retrieve. Prove.",
  "workflow": [
    "Capture",
    "Classify",
    "Link to aircraft",
    "Review",
    "Share"
  ],
  "intelligenceInContext": {
    "name": "vaultIQ",
    "headline": "Find any record in seconds",
    "helpsWith": [
      "Find any record in seconds",
      "Identify missing or conflicting records",
      "Assemble evidence packages"
    ],
    "drawsOn": [
      "Intelligence",
      "OEM content"
    ],
    "humanAuthority": "Record acceptance and corrections stay with records personnel.",
    "aiUsage": "Document processing uses credits; first-year credits included per tail."
  },
  "evidenceProduced": [
    "Permanent tail records",
    "Evidence packages",
    "Provenance history"
  ],
  "regulatory": {
    "anchors": [
      "p43-9",
      "p43-11",
      "p91-417",
      "p135-records"
    ],
    "included": [
      "Record-content checks",
      "Provenance",
      "Retention & export"
    ],
    "readinessServices": [
      "ext-records-audit"
    ]
  },
  "pricingId": "vault",
  "showExtensions": true
}